import React, { useState, useContext } from 'react';
import CloseButtonDialog from "App/components/CloseButtonDialog";
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from "@material-ui/core/styles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import {FoliosContext} from "App/Administracion/Folios/store";
import {LayoutContext} from "App/Layout/store";
import ConvertXML from 'xml-js';
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import LinearProgress from '@material-ui/core/LinearProgress';
import _ from 'underscore';

const styles = theme => ({
  table: {
    marginTop: 30,
  },
  gridContainer: {
    paddingRight: 30,
    marginTop: "0.1px"
  },
  borderRed: {
    borderStyle: "solid",
    marginTop: "0.1px",
    padding: 10,
    borderColor: "red"
  },
  labelPaddingTop: {
    paddingTop: "10px"
  },
  textField: {
    width: 200,
  },
});

function ObtenerFolios(props) {
    const foliosContext = useContext(FoliosContext);
    var layoutContext = useContext(LayoutContext);
    const [tipoDocumento, setTipoDocumento] = useState("");
    const [maximo, setMaximo]  = useState(" ");
    const [solicitud, setSolicitud] = useState("");
    const [cargando, setCargando] = useState(false);

    const { classes } = props;

    const content = (
        <Grid container>
            <Grid item xs={4}>
            <TextField
                  select
                  defaultValue=""
                  fullWidth
                  disabled = {cargando}
                  label="Tipo de Documento"
                  value={tipoDocumento}
                  onChange={e=>{
                      setTipoDocumento(e.target.value);
                      setCargando(true)
                      axios.get('/api/Administracion/Folio/Maximo/'+e.target.value).then(maximo=> {
                            setMaximo(maximo);
                        }).catch((e)=> {
                            console.log(e.response.data.Mensaje);
                            /*alert(e.response.data.Mensaje)*/;
                        }).finally(()=>setCargando(false))
                    }}>
                  {layoutContext.state.tiposDoc.filter(o => o.Electronico).map(option => (
                    <MenuItem key={option.ID} value={option.ID}>
                      {option.Nombre}
                    </MenuItem>
                  ))}
                  </TextField>
            </Grid>
            <Grid item xs={4}>
                <TextField
                    disabled
                    id="standard-disabled"
                    label="Maximo para Solicitar"
                    value={maximo!==''?maximo:"Ilimitado"}
                    fullWidth
                    />
            </Grid>
            <Grid item xs={4}>
            <TextField
                    label="Cantidad a Solicitar"
                    value={solicitud}
                    disabled = {cargando}
                    error = {maximo!=='' && solicitud>maximo}
                    onChange = {e=>setSolicitud(e.target.value)}
                    fullWidth
                    />
            </Grid>
            {cargando?
            <Grid item xs="12">
              <LinearProgress variant="query"/>
            </Grid>
            :null}
        </Grid>
    );

    const footer = (
        <DialogActions>
        <Button onClick={()=>foliosContext.dispatch({type:"toggleObtenerFolio"})} color="primary">
            Cancelar
        </Button>
        <Button onClick={()=>{ 
                if(maximo!=='' && solicitud>maximo){
                    alert("No se puede solicitar más del máximo")
                }else{
                axios.post('/api/Administracion/Folio/Obtener',{Tipo:tipoDocumento, Cantidad: solicitud}).then(e=> {
                    alert(e)
                }).catch((e)=> {
                    console.log(e.response.data.Mensaje);
                    /*alert(e.response.data.Mensaje)*/;
                })
                foliosContext.dispatch({type:"toggleObtenerFolio"});
                }
            }} color="primary" autoFocus>
            Solicitar
        </Button>
        </DialogActions>
    );

    return (
        <div>
        <CloseButtonDialog open={foliosContext.state.openObtenerFolios} onClose={()=>foliosContext.dispatch({type:"toggleObtenerFolio"})} closeButton title={"Obtener folios"} content={content} footer={footer} fullWidth size="md" />
        </div>
    );
}

export default withStyles(styles)(ObtenerFolios);